import {ArrowRight, ChevronDown, Download} from 'lucide-react';
import {memo, ReactElement} from 'react';
import {HeroWaveBackground} from './HeroWaveBackground';

const heroContent = {
  eyebrow: 'MSCS @ Georgia Tech / Ex-Amazon SDE II',
  title: 'Sai Hemanth Bheemreddy',
  subtitle: 'I build AI systems, compilers, and performance software. '
    + 'Basically, I help computers make better life choices.',
  primaryAction: {
    label: 'View selected work',
    href: '#projects'
  },
  secondaryAction: {
    label: 'Download resume',
    href: '/files/Resume.pdf'
  },
  stats: [
    {
      value: 'Georgia Tech',
      label: 'M.S. Computer Science'
    },
    {
      value: 'AI + Compilers',
      label: 'agents, IR, and codegen'
    },
    {
      value: 'Amazon',
      label: 'Ex-SDE II with 4 YOE'
    }
  ]
};

function HeroSection(): ReactElement {
  return (
    <>
      <HeroWaveBackground />

      <div className="section-inner hero-root">
        <div className="hero-copy">
          <p className="eyebrow">{heroContent.eyebrow}</p>
          <h1>{heroContent.title}</h1>
          <p className="hero-subtitle">{heroContent.subtitle}</p>

          <div className="hero-actions">
            <a href={heroContent.primaryAction.href} className="button button-primary">
              {heroContent.primaryAction.label}
              <ArrowRight aria-hidden="true" />
            </a>
            <a href={heroContent.secondaryAction.href} className="button button-secondary">
              {heroContent.secondaryAction.label}
              <Download aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="hero-stats" aria-label="Profile highlights">
          {heroContent.stats.map((stat) => (
            <div className="hero-stat" key={stat.label}>
              <span className="hero-stat-value">{stat.value}</span>
              <span className="hero-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>

        <div className="hero-scroll">
          <a href="#work">
            Scroll to explore
            <ChevronDown aria-hidden="true" />
          </a>
        </div>
      </div>
    </>
  );
}

export const Hero = memo(HeroSection);
